import { useState } from "react";
import { Menu, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const LINKS = [
  { label: "About", id: "#about-section" },
  { label: "Services", id: "#services-work" },
  { label: "Products", id: "#ebook-section" },
  { label: "FAQ", id: "#faq-section" },
  { label: "Articles", id: "#blog-section" },
];

export default function Navbar({ onBook, onNav }) {
  const [open, setOpen] = useState(false);
  const go = (id) => { setOpen(false); onNav(id); };

  return (
    <header data-testid="nav-header" className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#FAF7F0]/80 border-b border-[#2F3B2E]/10">
      <nav className="max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-8 lg:px-12 h-20 lg:h-24">
        <button onClick={() => go("#hero-section")} data-testid="nav-logo" className="flex items-center gap-3 text-left">
          <img src="/logo.jpeg" alt="Mended Alchemy — Life and Parenting Coaching" className="h-16 lg:h-20 w-auto rounded-full" />
          <span className="hidden sm:flex flex-col leading-tight">
            <span className="font-serif-display text-xl lg:text-2xl font-medium text-[#2F3B2E]">Mended Alchemy</span>
            <span className="font-mono-accent text-[9px] uppercase tracking-[0.22em] text-[#A8916B]">Life &amp; Parenting Coaching</span>
          </span>
        </button>

        <div className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <button key={l.id} onClick={() => go(l.id)} data-testid={`nav-link-${l.label.toLowerCase().replace(/ /g, "-")}`} className="text-sm text-[#3B352D]/75 hover:text-[#2F3B2E] transition-colors duration-200">
              {l.label}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <button onClick={onBook} data-testid="nav-book-button" className="hidden sm:inline-flex items-center rounded-full bg-[#2F3B2E] px-5 py-2.5 text-sm font-medium text-white hover:bg-[#232B22] transition-colors duration-200">
            Book a Consultation
          </button>
          <button onClick={() => setOpen((v) => !v)} data-testid="nav-menu-toggle" className="lg:hidden p-2 text-[#2F3B2E]" aria-label="Menu">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} exit={{ opacity: 0, height: 0 }} className="lg:hidden overflow-hidden bg-[#FAF7F0] border-t border-[#2F3B2E]/10" data-testid="nav-mobile-menu">
            <div className="px-6 py-4 flex flex-col gap-1">
              {LINKS.map((l) => (
                <button key={l.id} onClick={() => go(l.id)} className="py-3 text-left text-base text-[#3B352D]/80 hover:text-[#2F3B2E] transition-colors border-b border-[#2F3B2E]/5">
                  {l.label}
                </button>
              ))}
              <button onClick={() => { setOpen(false); onBook(); }} data-testid="nav-mobile-book" className="mt-3 rounded-full bg-[#2F3B2E] px-5 py-3 text-sm font-medium text-white">
                Book a Consultation
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
